import { call, put } from "redux-saga/effects";

import {
    getDeviceTypeFailure,
    getDeviceTypeSuccess,
    getDeviceOnboardingLogsSuccess,
    getDeviceOnboardingLogsFailure,
    getProcessNamesSuccess,
    getProcessNamesFailure,
} from "../components/device-onboarding/redux/actions";

import DeviceOnboardingService from "../components/device-onboarding/DeviceOnboardingService";

const deviceOnboardingService = new DeviceOnboardingService();


/**
 * Worker saga for loading device types
 */
function* loadDeviceTypes() {
    try {
        const deviceTypeList = yield call(
            deviceOnboardingService.getDeviceTypes
        );
        const filteredDeviceTypeList = deviceTypeList.filter(
            ({ deviceTypeId }) => [2, 9, 10, 11, 17].includes(deviceTypeId)
        );
        yield put(getDeviceTypeSuccess(filteredDeviceTypeList));
    } catch (error) {
        yield put(getDeviceTypeFailure(error.toString()));
    }
}

/**
 * Worker saga for loading process names from device types
 * Extracts all devices where type === 'processName' from the complete deviceTypeList
 */
function* loadProcessNames() {
    try {
        const deviceTypeList = yield call(
            deviceOnboardingService.getDeviceTypes
        );
        // Filter for all devices where type === 'processName' and use 'name' for dropdown
        const processNames = deviceTypeList
            .filter(device => device.type === 'processName')
            .map(device => ({
                label: device.name,
                value: device.name,
                deviceTypeId: device.deviceTypeId
            }));
        yield put(getProcessNamesSuccess(processNames));
    } catch (error) {
        yield put(getProcessNamesFailure(error.toString()));
    }
}

function* loadDeviceOnboardingLogs() {
    try {
        const onboardingLogs = yield call(
            deviceOnboardingService.getDeviceOnboardingLogs
        );
        yield put(getDeviceOnboardingLogsSuccess(onboardingLogs.map(log => ({
            ...log,
            deviceType: (() => {
                if(log.deviceTypeId===2) {
                    return "Modem Smart Switch"
                }
                if(log.deviceTypeId===9) {
                    return "Cradlepoint Smart Switch"
                }
                if(log.deviceTypeId===10) {
                    return "Pingprobe"
                }
                if(log.deviceTypeId===11) {
                    return "Aruba Controller"
                }
                if(log.deviceTypeId===17) {
                    // Display the selected process name for Custom Device (e.g., "Test Robotics")
                    return log.processName || "Custom Device";
                }
                return "Unknown";
            })()
        }))));
    } catch (error) {
        yield put(getDeviceOnboardingLogsFailure(error.toString()));
    }
}



export { loadDeviceTypes, loadDeviceOnboardingLogs, loadProcessNames };
